import { LoadableAfterPaint } from '@confluence/loadable';

import { EllipsisPlaceholder } from '../src/EllipsisPlaceholder.tsx';

export const EllipsisDropdownComponent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EllipsisDropdown" */ '../src/EllipsisDropdown.tsx'
			)
		).EllipsisDropdownComponent,
	loading: EllipsisPlaceholder,
});

export { Buttons } from '../src/types.ts';
